import React, { useEffect, useState } from "react";
import Loader from "../Common/Loader";
import { useLocation } from 'react-router-dom';
import { registerVerfiyUserByNumber } from '../../Utilities/controller'

const PublicUserInteractionPage = () => {
  const [userDetails, setUserDetails] = useState(null);
  const [loader, setLoader] = useState(false);

  // Use useLocation to get the location object
  const location = useLocation();

  useEffect(async() => {
    console.log("public page useEffect");

    // Use URLSearchParams to extract the country query parameter
    const queryParams = new URLSearchParams(location.search);
    const phone = queryParams.get('msisdn');
    const country = queryParams.get('country');
    console.log("country",country)

    setLoader(true);
    const userData = await registerVerfiyUserByNumber({phone: phone, phoneCode: country});

    console.log("userData --> ",userData);

    if(userData?.data?.success &&  userData?.data?.data?.token?.length > 0) {
      localStorage.setItem('token',userData?.data?.data?.token);
      localStorage.setItem('user-id', userData?.data?.data?.user?._id);
      if (!userData?.data?.data?.user?.gamerjiName.startsWith('goplay')) {
        localStorage.setItem('country', userData?.data?.data?.user?.address?.country);
        setLoader(false);
        window.location.href = '/home'
      } else {
        if(userData?.data?.data?.user?.address?.country) {
          localStorage.setItem('country', userData?.data?.data?.user?.address?.country);
        }
        setLoader(false);
        window.location.href = '/avatar'
      }
    }

  }, []);

  return (
    <>
        {loader ? <Loader /> : <></>}
    </>
  );
};

export default PublicUserInteractionPage;
